import {
  AdminApi,
  ActivitiesApi,
  ActivitiesSwitchingsApi,
  AuthApi,
  AppApi,
  EquipmentsApi,
  EquipmentSwitchingPremiseLinkApi,
  ExportApi,
  ImportApi,
  ImportFilesApi,
  JobClusterApi,
  ProjectsApi,
  ProjectsSinaApi,
  ResultFileApi,
  StorageApi,
  SubProjectsApi,
  SurveysApi,
  SwitchingBlockRestrictionsApi,
  SwitchingBlocksApi,
  SwitchingBlockSwitchingBlockRestrictionLinkApi,
  SwitchingPremisesApi,
  SwitchingsApi,
  TopologyApi,
  TopologyMatrixApi,
  UserFavoritesApi,
  UserManualFilesApi,
  UsersApi,
  SimulateApi,
  JobApi,
  ResultApi,
  SwitchingWindowApi,
} from '@gridcon-energy/schaltungstool-backend'
import { inject } from 'vue'
import { BackendClientKey } from '~/api/symbols'
import type { DeepPartial } from '~/types/helpers'
import type { Configuration } from '@gridcon-energy/schaltungstool-backend'
import mime from 'mime'
import { NUXT_PROXY_PREFIX } from '~/lib/constants'

const CRUDClients = {
  equipmentSwitchingPremiseLink: EquipmentSwitchingPremiseLinkApi,
  equipments: EquipmentsApi,
  importFiles: ImportFilesApi,
  projects: ProjectsApi,
  subProjects: SubProjectsApi,
  switchingBlockRestrictions: SwitchingBlockRestrictionsApi,
  switchingBlockSwitchingBlockRestrictionLink: SwitchingBlockSwitchingBlockRestrictionLinkApi,
  switchingBlocks: SwitchingBlocksApi,
  switchingPremises: SwitchingPremisesApi,
  switchings: SwitchingsApi,
  activity_switchings: ActivitiesSwitchingsApi,
  userFavorites: UserFavoritesApi,
  users: UsersApi,
  userManualFilesApi: UserManualFilesApi,
}
const HansApiClients = {
  ...CRUDClients,
  adminApi: AdminApi,
  app: AppApi,
  importer: ImportApi,
  exporter: ExportApi,
  topology: TopologyApi,
  activity: ActivitiesApi,
  authApi: AuthApi,
}

const SinaApiClients = {
  storageApi: StorageApi,
  simulateApi: SimulateApi,
  jobApi: JobApi,
  resultApi: ResultApi,
  resultFileApi: ResultFileApi,
  projectsSinaApi: ProjectsSinaApi,
  surveysApi: SurveysApi,
  jobClusterApi: JobClusterApi,
  switchingWindow: SwitchingWindowApi,
  topologyMatrixApi: TopologyMatrixApi,
}

export type SinaBackend = {
  [key in keyof typeof SinaApiClients]: InstanceType<(typeof SinaApiClients)[key]>
}

export type BackendClients = {
  [key in keyof typeof HansApiClients]: InstanceType<(typeof HansApiClients)[key]>
} & {
  sina: SinaBackend
}

export function createBackendClients(token: () => string, baseURL: string = NUXT_PROXY_PREFIX): BackendClients {
  const config: Configuration = {
    basePath: baseURL,
    accessToken: token,
    isJsonMime(type): boolean {
      return mime.getExtension(type) === 'json'
    },
  }

  const clients: DeepPartial<BackendClients> = {
    sina: {},
  }
  for (const value of Object.keys(HansApiClients)) {
    const key = value as keyof typeof HansApiClients
    clients[key] = new HansApiClients[key](config)
  }
  for (const value of Object.keys(SinaApiClients)) {
    const key = value as keyof typeof SinaApiClients
    clients.sina ??= {}
    clients.sina[key] = new SinaApiClients[key](config)
  }
  return clients as BackendClients
}

export function injectBackendClient() {
  const backend = inject(BackendClientKey)
  if (!backend) {
    throw Error('Backend clients missing')
  }
  return backend
}
